//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const layoutId = 'calendar-view-layout';

export default {
  data() {
    return {
      showDialog: false,
      availableColumns: ['days', 'weeks', 'months', 'backlog'],
      defaultDBname: this.$defaultDB.name,
    };
  },
  computed: {
    layoutDoc() {
      return this.$reactiveCache.docs[layoutId];
    }
  },
  methods: {
    updateCalendarLayout() {
      const layout = [];
      for (const id of this.availableColumns) {
        if (this.$root.activeTimeCols.includes(id)) layout.push(id);
      }
      this.layoutDoc.layout = layout;
      this.layoutDoc.save();
    },
    saveDefaultDB() {
      this.$settings.clone({defaultDBname: this.defaultDBname}).save();
    }
  },
  mounted() {
    this.$root.$on('time-board-settings', data => {
      this.showDialog = true;
    });
    for (const id of this.$root.plannedForLists.map(list => list._id)) {
      this.availableColumns.push(id);
    }
    for (const id of this.availableColumns) {
      if (this.layoutDoc?.layout.includes(id)) this.$root.activeTimeCols.push(id);
    }
  },
};
